<h1 mat-dialog-title>{{data.title}}</h1>
<form>
    <!--
        title: string;
        name: string;
        description: string;
        jurisdiction: string;
        type: string;
        duration: string;
        date: string;
        active: boolean;
    -->
    <mat-form-field>
        <input matInput name="policy-name" placeholder="Name" [(ngModel)]="data.name" cdkFocusInitial>
    </mat-form-field>

    <mat-form-field>
        <textarea matInput name="policy-description" placeholder="Description" [(ngModel)]="data.description"></textarea>
    </mat-form-field>

    <mat-form-field>
        <mat-select name="policy-jurisdiction" placeholder="Jurisdiction" [(ngModel)]="data.jurisdiction">
            <mat-option *ngFor="let juris of jurisdictions" [value]="juris">{{juris}}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field>
        <mat-select #policyType name="policy-type" placeholder="Type" [(ngModel)]="data.type">
            <!-- <mat-option *ngFor="let type of policyTypes" [value]="type">{{type}}</mat-option> -->
            <mat-option value="Duration">Duration</mat-option>
            <mat-option value="Fixed">Fixed</mat-option>
        </mat-select>
    </mat-form-field>

    <!-- <mat-form-field *ngIf="data.type=='Duration'">
        <input matInput name="policy-duration" placeholder="Duration" [(ngModel)]="data.duration" [matAutocomplete]="autoPolicyType">
    </mat-form-field>

    <mat-autocomplete #autoPolicyType>
        <input matInput name="policy-duration-years" placeholder="Years" [(ngModel)]="data.duration.years">
        <input matInput name="policy-duration-months" placeholder="Months" [(ngModel)]="data.duration.months">
        <input matInput name="policy-duration-" placeholder="Days" [(ngModel)]="data.duration.days">
        <mat-option [value]="durations">{{durations}}</mat-option>
    </mat-autocomplete> -->

    <mat-form-field *ngIf="data.type=='Duration'">
        <input matInput name="policy-duration-years" placeholder="Years" [(ngModel)]="data.duration.years">
    </mat-form-field>
    <mat-form-field *ngIf="data.type=='Duration'">
        <input matInput name="policy-duration-months" placeholder="Months" [(ngModel)]="data.duration.months">
    </mat-form-field>
    <mat-form-field *ngIf="data.type=='Duration'">
        <input matInput name="policy-duration-" placeholder="Days" [(ngModel)]="data.duration.days">
    </mat-form-field>

    <mat-form-field *ngIf="data.type=='Fixed'">
        <input matInput name="policy-date" [matDatepicker]="datePicker" placeholder="Date" [(ngModel)]="data.date">
        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
    </mat-form-field>

    <!-- <mat-checkbox name="policy-active" [(ngModel)]="data.active">Active</mat-checkbox> -->
</form>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">{{data.button}}</button>
    <button mat-button (click)="onNoClick()">Cancel</button>
</mat-dialog-actions>